import { render, staticRenderFns } from "./AddFormInformation.vue?vue&type=template&id=03a11870"
import script from "./AddFormInformation.vue?vue&type=script&lang=js"
export * from "./AddFormInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports